import axios from "axios";

import {
  actionLoginError,
  actionLoginLoading,
  actionLoginSuccess,
  actionsignUpLoading,
  actionsingUpError,
  actionsingUpSuccess,
} from "./actionType";

let baseURL = process.env.REACT_APP_API_URL;

export const loginFetch = (value) => (dispatch) => {
  dispatch(actionLoginLoading());
  return axios
    .post(`${baseURL}/api/auth/login`, value)
    .then((res) => {
      dispatch(actionLoginSuccess(res.data));

    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || err.message;
      dispatch(actionLoginError(errorMsg));
      console.log(err);
      throw err;
    });
};

export const ssoLoginFetch = (value) => (dispatch) => {
  dispatch(actionLoginLoading());
  return axios
    .post(`${baseURL}/api/auth/sso`, value)
    .then((res) => {
      dispatch(actionLoginSuccess(res.data));
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || err.message;
      dispatch(actionLoginError(errorMsg));
      console.log(err);
      throw err;
    });
};

export const signUpFetch = (value) => (dispatch) => {
  dispatch(actionsignUpLoading());
  return axios
    .post(`${baseURL}/api/auth/register`, value)
    .then((res) => {
      dispatch(actionsingUpSuccess());
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || err.message;
      dispatch(actionsingUpError(errorMsg));
      console.log(err);
      throw err;
    });
};

// conver 1 letter to upper case and rest to lower
export function capitalizeFirstLetter(string) {
  const words = string?.split(" ");
  const capitalizedWords = words?.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );
  return capitalizedWords?.join(" ");
}


export function writeLocalStorage(key,data){
    localStorage.setItem(key,JSON.stringify(data))
}
